module.exports = __webpack_public_path__ + "static/media/thumb.8bb05ef1.jpg";